// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topnoti {\n  width: 26px;\n  height: 26px;\n}\n.topnoti i {\n  margin-top: -8px;\n  margin-left: -6px;\n}\n.topnoti .q-badge {\n  font-size: 8px !important;\n  min-width: 8px !important;\n  min-height: 8px !important;\n  width: 8px !important;\n  height: 8px !important;\n  padding: 0px;\n  margin-top: 5px;\n  margin-right: 5px;\n}\n.headerTaskDateBtn {\n  margin-right: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
